<template>
  <div class="details-container">
    <div
      v-if="isMobile"
      class="back-menu mobile-position-fixed"
    >
      <mobile-back-menu :title="$t('menu.help.title')" />
    </div>
    <div class="details-wrapper">
      <div class="left-menu">
        <div>
          <el-button-group class="menu">
            <router-link
              :to="{ name: 'About' }"
              tag="button"
            >
              <span>{{ $t('details.about-us') }}</span>
            </router-link>
            <!--<router-link :to="{ name: 'GettingStarted' }" tag="button">{{ $t('Getting Started') }}</router-link>-->
            <router-link
              :to="{ name: 'Terms of use' }"
              tag="button"
            >
              <span>{{ $t('details.terms-of-use') }}</span>
            </router-link>
            <router-link
              :to="{ name: 'Trust and Safety' }"
              tag="button"
            >
              <span>{{ $t('details.trust-and-safety') }}</span>
            </router-link>
            <!--<router-link :to="{ name: 'Privacy policy' }" tag="button">{{ $t('Privacy')}}</router-link>-->
            <!--<router-link :to="{ name: 'Terms and Conditions' }" tag="button">{{ $t('Terms&Conditions')}}</router-link>-->
            <router-link
              :to="{ name: 'Contact' }"
              tag="button"
            >
              <span>{{ $t('details.contact') }}</span>
            </router-link>
          </el-button-group>
        </div>
        <div>
          <el-button-group
            v-if="!isMobile && socialLinks"
            class="social-buttons"
          >
            <a
              v-if="socialLinks.facebook"
              icon="icon-facebook"
              :href="socialLinks.facebook"
              target="_blank"
            ><i class="icon-facebook" /></a>
            <a
              v-if="socialLinks.instagram"
              icon="icon-instagram"
              :href="socialLinks.instagram"
              target="_blank"
            ><i class="icon-instagram-logo" /></a>
            <a
              v-if="socialLinks.youtube"
              icon="icon-youtube"
              :href="socialLinks.youtube"
              target="_blank"
            ><i class="icon-youtube" /></a>
            <a
              v-if="socialLinks.linkedin"
              icon="icon-linkedin"
              :href="socialLinks.linkedin"
              target="_blank"
            ><i class="icon-linkedin" /></a>
          </el-button-group>
        </div>
        <div>
          <div
            v-if="!isMobile"
            class="made"
          >
            <span>{{ $t('about.made.first') }}<i class="icon-heart" /> {{ $t('about.made.second') }}</span>
          </div>
        </div>
      </div>
      <div class="details-content">
        <router-view />
      </div>
      <div
        v-if="isMobile && socialLinks"
        class="left-menu"
      >
        <el-button-group
          class="social-buttons d-flex justify-center"
          :class="{mobile: isMobile}"
        >
          <a
            v-if="socialLinks.facebook"
            icon="icon-facebook"
            :href="socialLinks.facebook"
            target="_blank"
          ><i class="icon-facebook" /></a>
          <a
            v-if="socialLinks.instagram"
            icon="icon-instagram"
            :href="socialLinks.instagram"
            target="_blank"
          ><i class="icon-instagram-logo" /></a>
          <a
            v-if="socialLinks.youtube"
            icon="icon-youtube"
            :href="socialLinks.youtube"
            target="_blank"
          ><i class="icon-youtube" /></a>
          <a
            v-if="socialLinks.linkedin"
            icon="icon-linkedin"
            :href="socialLinks.linkedin"
            target="_blank"
          ><i class="icon-linkedin" /></a>
        </el-button-group>
        <div class="made">
          <span>{{ $t('about.made.first') }}<i class="icon-heart" /> {{ $t('about.made.second') }}</span>
        </div>
      </div>
    </div>
    <!--    <el-col v-if="isMobile">-->
    <!--      <footer-menu></footer-menu>-->
    <!--    </el-col>-->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MobileBackMenu from '../components/Mobile/MobileBackMenu';

export default {
  components: { MobileBackMenu },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      socialLinks: state => state.config.socialLinks,
    }),
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Details.vue